import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";

export const getMeTelegramRequest = reatomAsync(() => {
  return API.telegramApi
    .telegramControllerGetMeTelegram()
    .then((response) => response.data);
}, "getMeTelegram").pipe(withDataAtom(null));
